export type UserRoles = 'Admin' | 'Employee'

export class CreateEmployeeVariables {
  public first_name: string
  public last_name: string
  public email: string
  public password: string | undefined
  public phone_number: string
  public roles: UserRoles[]
  public social_number: string
  public job_tittle: string
  public address: string
  public hour_rate: string
  public bank_account: string
  public tax_card_last_update: string
  public last_seen?: Date | undefined
  public city: string

  constructor(user: CreateEmployeeVariables) {
    const errors = []

    if (!user.email) {
      errors.push('Missing email')
    }

    if (!user.first_name) {
      errors.push('Missing first name')
    }

    if (!user.last_name) {
      errors.push('Missing last name')
    }

    if (!user.city) {
      errors.push('Missing city')
    }

    if (!user.roles || user.roles.length === 0) {
      errors.push('Missing roles')
    }

    if (errors.length > 0) {
      throw JSON.stringify(errors)
    }

    this.first_name = user.first_name
    this.last_name = user.last_name
    this.email = user.email
    this.password = user.password
    this.phone_number = user.phone_number
    this.roles = user.roles
    this.social_number = user.social_number
    this.job_tittle = user.job_tittle
    this.address = user.address
    this.hour_rate = user.hour_rate
    this.bank_account = user.bank_account
    this.tax_card_last_update = user.tax_card_last_update
    this.city = user.city
  }
}

export class Employee extends CreateEmployeeVariables {
  _id: string

  constructor(user: Employee) {
    super(user)

    if (!user._id) {
      throw '_id'
    }

    this._id = user._id
  }
}

export type EmployeesQueryParams = {
  employee_id?: string[]
  roles?: string[]
}

export type EmployeesQueryParamValues = { key: 'employee_id'; value: string[] | undefined } | { key: 'roles'; value: string[] | undefined }

/*
export type User = {
  _id: string
  first_name: string
  last_name: string
  email: string
  phone_number: string
  roles: UserRoles[]
  last_login: Date
  last_resume_login: Date
}
 */
